/* tslint:disable */
/* eslint-disable */
/* @relayHash 2402af8b22a6638fae1348523b6730f5 */

import { ConcreteRequest } from "relay-runtime";
export type zipCodeLookupQueryVariables = {
    zipCode: string;
    country: string;
};
export type zipCodeLookupQueryResponse = {
    readonly viewer: {
        readonly zipCode: ReadonlyArray<{
            readonly city: string | null;
            readonly state: string | null;
            readonly country: string | null;
        } | null> | null;
    };
};
export type zipCodeLookupQuery = {
    readonly response: zipCodeLookupQueryResponse;
    readonly variables: zipCodeLookupQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "zipCode"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "zipCodeLookupQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "zipCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Address",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "zipCodeLookupQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "zipCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Address",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "zipCodeLookupQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/zipCodeLookupQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e8c10a44b9376bcc81c18823387740fc';
export default node;
